import { BaseAbstractService } from "@common/service/base-service/global";
import { ICTRequestService } from "@common/ict/service/base-service/request";
import { ICTLoginApi } from "@common/ict/api/login";
import {
  CheckSliderDto,
  GetICTVerifyCodeDto,
  GetICTEmailVerifyCodeDto,
  GetPhoneCodeLSDto,
  ICTLoginRes,
  LoginByVerifyCodeDto,
  LoginLSDto,
  RegisterUserLSDto,
  RegisterUserLSDtoNew,
  ResetPasswordLSDto,
  FirstPasswordLSDto
} from "@common/ict/model/interface/login";
import Message from "@common/ict/components/message";
export class ICTLoginService extends BaseAbstractService {
  static loginByPassword(loginInfo: any) {
    return ICTLoginApi.doLogin(this.request, loginInfo).then(res => {
      return this.handleLoginInfo();
    });
  }
  static loginByPhone(loginInfo: LoginLSDto): Promise<ICTLoginRes> {
    return ICTLoginApi.doLogin(this.request, loginInfo).then(res => {
      return this.handleLoginInfo();
    });
  }

  static handleLoginInfo() {
    return this.getLoginInfo().then(userInfo => {
      return {
        userInfo
      };
    });
  }

  static getLoginInfo() {
    return ICTLoginApi.getLoginInfo(this.request).then(res => {
      return res.data;
    });
  }

  static getImageCode(): Promise<{ imageCode: string; imageKey: string }> {
    return ICTLoginApi.getImageCode(this.request).then(res => {
      return Object.assign(res.data, {
        imageCode: `data:image/jpg;base64,${res.data.imageCode}`
      });
    });
  }

  static getPhoneCode(info: GetPhoneCodeLSDto) {
    return ICTLoginApi.getPhoneCode(this.request, info).then(res => {
      return res.data;
    });
  }

  static registerUser(info: RegisterUserLSDto) {
    return ICTLoginApi.registerUser(this.request, info);
  }

  static resetPassword(info: ResetPasswordLSDto) {
    return ICTLoginApi.resetPassword(this.request, info);
  }

  static firstPassword(info: FirstPasswordLSDto) {
    return ICTLoginApi.firstPassword(this.request, info);
  }

  // 滑块验证
  static sliderLoginVerify(data: string) {
    return ICTLoginApi.sliderLoginVerify(this.request, data);
  }

  // 获取校验码
  static getVerifyCode() {
    return ICTLoginApi.getVerifyCode(this.request);
  }
  // 密码登录
  static pwdLogin(data) {
    return ICTLoginApi.pwdLogin(this.request, data);
  }
  static getICTVerifyCode(data: GetICTVerifyCodeDto) {
    return ICTLoginApi.getICTVerifyCode(this.request, data).then((res: any) => {
      if (res.status == 4000200) {
        return true;
      }
      Message.warning(res.message);
      return false;
    });
  }
  static getICTVerifyEmailCode(data: GetICTEmailVerifyCodeDto) {
    return ICTLoginApi.getICTVerifyEmailCode(this.request, data).then(res => {
      return res;
    });
  }
  static registerByVerifyCode(data: RegisterUserLSDtoNew) {
    return ICTLoginApi.registerByVerifyCode(this.request, data).then(res => {
      return res;
    });
  }
  static loginByVerifyCode(data: LoginByVerifyCodeDto) {
    return ICTLoginApi.loginByVerifyCode(this.request, data).then(res => {
      return res;
    });
  }
  static checkSliderRes(data: CheckSliderDto) {
    return ICTLoginApi.checkSliderRes(this.request, data).then(res => {
      return res.data;
    });
  }
  static registerByVerifyPhone(data: any) {
    return ICTLoginApi.registerByVerifyPhone(this.request, data).then(res => {
      return res.data;
    });
  }
  static resetUserPassword(data: any) {
    return ICTLoginApi.resetUserPassword(this.request, data).then(res => {
      return res;
    });
  }
  static resetUserPasswordTob(data: any) {
    return ICTLoginApi.resetUserPassword(this.request, data).then(res => {
      return res;
    });
  }
  static logOut() {
    return ICTLoginApi.logOut(this.request).then(res => {
      if (res.status === 4000200 || res.status === 4000403) {
        // 后端对退出登录进行鉴权，若退出登录403，说明登录信息已经失效了，前端可以直接判断退出
        return true;
      }
      return false;
    });
  }
  static firstSetPwd(data) {
    return ICTLoginApi.firstSetPwd(this.request, data);
  }
}
ICTLoginService.setRequest(ICTRequestService);
